import React, { FC, useEffect } from 'react'
import { useAppDispatch, useAppSelector } from '../../store/hooks'
import { scrollToTop } from '../../utils'
import { fetchByDetailProduct } from '../../store/slices/productsSlice'
import { NavLink, useParams } from 'react-router-dom'
import TopBanner from '../../components/TopBanner/TopBanner'
import Breadcrumbs from '../../components/Breadcrumbs/Breadcrumbs'
import Loader from '../../components/Loader/Loader'
import { Helmet } from 'react-helmet-async'
import HeroSection from './HeroSection/HeroSection'
import ProductInfoSection from './ProductInfoSection/ProductInfoSection'
import TechnicalSection from './TechnicalSection/TechnicalSection'
import DocumentsSection from './DocumentsSection/DocumentsSection'

const DetailProduct: FC = () => {
    const { id, name } = useParams()
    const dispatch = useAppDispatch()
    const { detail, loading } = useAppSelector(state => state.products)

    useEffect(() => {
        if (id) {
            scrollToTop()
            dispatch(fetchByDetailProduct(Number(id)))
        }
    }, [dispatch, id])

    return (
        <>
            <Helmet>
                <meta property="og:title" content={`${name} | Продукция | Phoenix Programs`} />
                <meta property="og:description" content={`${name} - продукция от Phoenix Programs`} />
                <meta name="twitter:title" content={`${name} | Продукция | Phoenix Programs`} />
                <meta name="twitter:description" content={`${name} - продукция от Phoenix Programs`} />
                <link rel="canonical" href={`https://phoenix-programs.com/products/${id}/${encodeURIComponent(name || '')}`} />
                <title>{`${name} | Продукция | Phoenix Programs`}</title>
            </Helmet>
            {loading && <Loader />}
            <TopBanner title={name} />
            <Breadcrumbs>
                <NavLink to={'/'}>Главная</NavLink>
                /
                <NavLink to={`/products`}>Продукция</NavLink>
                /
                <span>{name}</span>
            </Breadcrumbs>

                {detail && (
                    <div style={{overflow:'hidden'}}>
                        <HeroSection mainImage={detail.main_image} title={detail.title} />
                        <ProductInfoSection
                            aboutText={detail.about_text}
                            icon={detail.about_icon}
                            featuresDescription={detail.features_description}
                            featuresList={detail.features_list}
                            featuresImage={detail.features_image}
                        />
                        <TechnicalSection
                            schemaImage={detail.schema_image}
                            interactionsText={detail.interactions_text}
                            interactionsImage={detail.interactions_image}
                        />
                        <DocumentsSection 
                            documents={detail.documents} 
                            pricingInfo={detail.pricing_info}
                        />
                    </div>
                )}
        </>
    )
}

export default DetailProduct

